const logIn = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><rect width="8.5" height="12.5" x="1.75" y="1.75" stroke-width="1.5"/><path stroke-width="0" d="m8.1 4.605-3.5 3.5 3.5 3.5V8.899l7.5.001V7.1l-7.5-.001z"/></svg>',
};

export { logIn as default };
